import { DataLayerEvents, FileDownloadEvent } from '@helpers/dataLayer';
import { getFileDownloadInfo } from '@helpers/getFileDownloadInfo';
import { isSSR } from '@helpers/ssr';

const ensureDataLayer = (): void => {
  if (isSSR) {
    return;
  }

  if (window.dataLayer === null || window.dataLayer === undefined || !Array.isArray(window.dataLayer)) {
    window.dataLayer = [];
  }
};

const pushToDataLayer = (request: DataLayerEvents): void => {
  window.dataLayer.push(request);
  console.log(`Pushing new request (length: ${JSON.stringify(request).length})`, request);
};

export interface FileDownloadProps {
  linkUrl: string;
  itemName?: string;
  itemVariant?: string;
  overrides?: Partial<FileDownloadEvent>;
}
const fileDownload = ({ linkUrl, itemName, itemVariant, overrides }: FileDownloadProps): void => {
  const [fileName, fileExtension] = getFileDownloadInfo(linkUrl);

  const request: FileDownloadEvent = {
    event: 'file_download',
    link_url: linkUrl,
    file_name: fileName,
    file_extension: fileExtension,
    // As per MW-4714, item_name is now the variant code code, and item_model is the overall model code (in this case itemName) //
    ...(itemVariant ? { item_name: itemVariant } : {}),
    ...(itemName ? { item_model: itemName } : {}),
    ...overrides,
  };

  pushToDataLayer(request);
};

export const useGA4Tracking = () => {
  ensureDataLayer();

  return {
    fileDownload,
  };
};
